import React, {Component} from 'react';
import {getArticle} from '../../actions/article';
import {connect} from 'react-redux';
import PageTitle from '../common/page-title/index';
import {Grid, Row, Col} from 'react-bootstrap';
import no_photo from '../../assets/img/no_photo.png';
import InlineCKEditor from "../common/editor/inline-editor/index";
import {dateFormat} from '../../utils/commonFunctions';
import ArticleList from '../common/article/article-list'
import ArrowButton from '../common/button-arrow'
import {history} from '../../store';
import "./style.css";

class ArticlePage extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    this.props.dispatch(getArticle(this.props.match.params.id));
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.match.params.id !== this.props.match.params.id) {
      this.props.dispatch(getArticle(nextProps.match.params.id));
    }
  }

  componentWillUnmount() {
    this.props.dispatch({type: 'CLEAR_NEWS_ARTICLE'});
  }

  createArticleList = (data) => {
    return data.map((curr) => {
      return {
        id: curr.id.toString(),
        attributes: {
          ...curr
        }
      };
    });
  };

  render() {
    let image = no_photo;
    if (this.props.article.attributes && this.props.article.attributes.link.image != null) {
      image = this.props.article.attributes.link.image;
    }
    let title = this.props.article.attributes
      ? this.props.article.attributes.title
      : "";
    let date = this.props.article.attributes
      ? dateFormat(this.props.article.attributes['display-from-date'])
      : "";
    return (
      <Grid bsClass="container" className="article">
        <Row>
          <Col lg={12} className="article-page-title" >
            <PageTitle articleTitle = {title}>News</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              arrow={{
                direction: 'left'
              }}
              color="grey"
              onClick={() => history.goBack()}>
                Back to news
              </ArrowButton>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="text-center">
            <Row className="article-display-from">
              <span>{date}</span>
            </Row>
            <Row>
              <h2 className="title">{title}</h2>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="content-page">
            {this.props.meta &&
            <InlineCKEditor
              identifier={this.props.meta.contents[0].identifier}
              contents={this.props.meta.contents[0]}
              activeClass="content-editor"
              config={{
                width: '100%',
                height: '100%'
              }}
              onContentSaved={() => this.props.dispatch({
                type: 'TOGGLE_EDIT_CONTENT',
                payLoad: false
              })}/>}
          </Col>
        </Row>
        {
          this.props.article.attributes && this.props.article.attributes["linked-articles"].length > 0 &&
          <Row>
            <Col lg={12}>
              <PageTitle ignoreForDoc >Related news</PageTitle>
            </Col>
            <Col lg={12}>
              <ArticleList articles={this.createArticleList(this.props.article.attributes["linked-articles"])}/>
            </Col>
          </Row>
        }
      </Grid>
    )
  }
}

ArticlePage.propTypes = {};

const mapStateToProps = (state) => {
  return {
    article: state.article.article,
    meta: state.article.meta
  };
};

export default connect(mapStateToProps)(ArticlePage)



// WEBPACK FOOTER //
// ./src/components/article/index.jsx